<template>
  <div class="tournament-tabs-wrapper">
    <template v-if="list.length">
      <div v-for="(item, itemIdx) in list" class="tournament-tab" :key="item.id + (item?.name || 'nothing')">
        <div class="content"
             :id="idName + item.id"
             @click="clickByTab(item)"
             :class="[modelTab === item.id && 'active']">
          <slot name="item" :item="{item, isActive: modelTab === item.id && 'active'}">{{ item.name }}</slot>
        </div>
        <div class="actions" v-if="!hideActions">
          <template v-if="!onlyViewAction">
            <slot name="moreActions" :item="{ item, itemIdx }" />
            <button @click="$emit('edit', item.id)" v-b-tooltip.hover.top="`Редактировать ${ tabName }`"><img :src="PenIcon" alt=""></button>
            <button v-if="!hideDeleteAction" @click="$emit('delete', item.id)" v-b-tooltip.hover.top="`Удалить ${ tabName }`"><img :src="TrashIcon" alt=""></button>
          </template>
          <template v-else>
            <button @click="$emit('view', item.id)"><img :src="EyeIcon" alt=""></button>
          </template>
        </div>
      </div>
    </template>
    <div v-else class="pug-text">
      <slot name="pug">
        <h6>Элементов нет</h6>
      </slot>
    </div>
  </div>
</template>

<script>
import PenIcon from '@/assets/icons/pen.svg'
import TrashIcon from '@/assets/icons/trash-black.svg'
import EyeIcon from '@/assets/icons/eye.svg'

export default {
  name: "TournamentTabs",
  props: {
    value: {
      type: [Number, String],
    },
    list: {
      type: Array,
      required: true
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    idName: {
      type: String,
      default: ''
    },
    tabName: {
      type: String,
      default: ''
    },
    onlyViewAction: {
      type: Boolean,
      default: false
    },
    hideDeleteAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      PenIcon,
      TrashIcon,
      EyeIcon
    }
  },
  computed: {
    modelTab: {
      get() { return this.value },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  methods: {
    clickByTab(item) {
      this.modelTab = item.id
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.tournament-tabs-wrapper {
  @include tf-tokens-light;

  display: flex;
  flex-direction: column;
  gap: 2px;

  & > .tournament-tab {
    display: flex;
    align-items: center;
    gap: 4px;

    /* действия появляются на ховере строки, чтобы список не рябил иконками */
    &:hover .actions button { opacity: 1; }

    .content {
      position: relative;
      width: 100%;
      min-width: 0;
      display: flex;
      align-items: center;
      padding: 9px 12px;
      border: 1px solid transparent;
      border-radius: 10px;
      color: var(--tf-text);
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: background .14s ease, color .14s ease, border-color .14s ease;

      & * { white-space: nowrap; }

      img {
        width: 13px;
        height: 13px;
        margin-left: 8px;
        opacity: .75;
      }

      &:hover { background: var(--tf-soft); border-color: var(--tf-border); }

      /* активный этап/группа: заливка, рамка и метка слева */
      &.active {
        background: var(--tf-primary-soft);
        border-color: var(--tf-primary);
        color: var(--tf-primary);
        font-weight: 700;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 60%;
          border-radius: 0 3px 3px 0;
          background: var(--tf-primary);
        }

        img { opacity: 1; }
      }
    }

    .actions {
      display: flex;
      gap: 2px;
      flex: 0 0 auto;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: transparent;
        opacity: 0;
        transition: opacity .14s ease, background .14s ease;

        &:hover, &:focus { background: var(--tf-soft-2); opacity: 1; }
      }

      img {
        width: 11px;
        height: 11px;
        display: block;
        opacity: .65;
      }
    }
  }

  .pug-text h6 {
    margin: 10px 0;
    text-align: center;
    color: var(--tf-muted);
    font-size: 12.5px;
    font-weight: 400;
  }
}

body.dark-only .tournament-tabs-wrapper {
  @include tf-tokens-dark;
}
</style>